import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { money } from '../../utils/helpers'
import { changeLineItem } from '../../utils/Cart.js'

const CartItems = () => {
  const dispatch = useDispatch()
  const { cart } = useSelector((state) => state.cart)

  return (
    <ul className='flex flex-col gap-6 pb-6 w-full'>
      {
        cart.items.map((item, index) =>
          <li className='w-full flex justify-between gap-3 lg:gap-4 h-[6.25rem] lg:h-[7.8125rem]' key={`item-${index}`}>
            {
              item.image && 
              <a className={`relative block w-20 h-[6.25rem] lg:w-[6.25rem] lg:h-[7.8125rem] before:content-[''] before:inset-px before:absolute before:border before:border-[rgba(67,69,72,0.25)] overflow-hidden before:z-[1]`} href={item.url}>
                <img className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain' src={item.image} alt={item.title} />
              </a>
            }
            <div className='h-full flex flex-col justify-between grow'>
              <div>
                {item.properties && (typeof item.properties['Final Sale'] != 'undefined') && <span className="px-2 py-1 bg-[rgba(6,14,41,0.1)] text-black text-sm leading-4 inline-block mb-1">Final Sale</span>}
                <div className='flex gap-6 text-second text-base justify-between items-center'>
                  <a className='text-second text-base uppercase no-underline hover:underline' href={item.url}>{item.product_title}</a>
                  <div className='text-second text-sm leading-4 text-right'>
                    {money(item.final_line_price)}
                    {item.original_line_price > item.final_line_price && <br />}
                    {item.original_line_price > item.final_line_price && <span className='opacity-70 line-through'>{money(item.final_line_price)}</span>}
                  </div>
                </div>
                { item.variant_title != 'Default Title' && <div className='font-tinos mt-1 text-sm leading-4 capitalize text-second'>{item.variant_title}</div> }
              </div>
              <div className='flex items-center gap-6'>
                <div className='inline-flex items-center gap-3'>
                  <button className='text-second text-sm leading-4'
                    onClick={(e) => {changeLineItem(null, {'line': index + 1, 'quantity': item.quantity - 1})}}>
                    –
                  </button>
                  <span className='font-tinos text-second text-sm leading-4 underline'>{item.quantity}</span>
                  <button className='text-second text-sm leading-4'
                    onClick={(e) => {changeLineItem(null, {'line': index + 1, 'quantity': item.quantity + 1})}}>
                    +
                  </button>
                </div>
                <button className='underline font-tinos text-second text-sm leading-4' 
                  onClick={(e) => {changeLineItem(null, {'line': index + 1, 'quantity': 0})}}>
                  Remove
                </button>
              </div>
            </div>
            
          </li>
        )
      }
    </ul>
  )
}

export default CartItems